<template>
  <div class="group_container">
    <ul class="group_ul">
      <li class="title">
        <div class="zh">{{ zh }}</div>
        <div class="en">{{ en }}</div>
      </li>
      <router-link
        tag="li"
        class="group_li"
        v-for="item in list"
        :key="item.id"
        :to="item.path"
      >
        {{ item.label }}
        <i class="icon el-icon-arrow-right"></i>
      </router-link>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'JsGroup',
  props: {
    zh: String,
    en: String,
    list: Array
  }
}
</script>

<style lang="scss" scoped>
.group_container {
  min-width: 220px;
  .group_ul {
    border: 1px solid #EEE;
    border-bottom: none;
    .title  {
      display: flex;
      flex-direction: column;
      padding: 10px 15px;
      color: #00439a;
      .zh {
        font-size: 32px;
        font-weight: 500;
      }
      .en {
        font-size: 18px;
        margin-top: 10px;
      }
    }
    .group_li {
      padding: 10px 15px;
      border-top: 1px solid #EEE;
      border-bottom: 1px solid #EEE;
      .icon {
        float: right;
      }
      &.active, &:hover {
        border-top: 1px solid #00439a;
        border-bottom: 1px solid #00439a;
        cursor: pointer;
        color: #00439a;
        .icon {
          color: #00439a;
        }
      }
    }
  }
}
</style>
